<template>
    <div class="dashboard-container">
      <!-- 筛选条件区域 -->
      <el-card class="filter-container">
        <div class="filter-item">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions">
          </el-date-picker>
          
          <el-select v-model="department" placeholder="科室选择" multiple style="width: 180px; margin-left: 10px">
            <el-option v-for="item in departmentOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          
          <el-select v-model="planType" placeholder="随访计划类型" style="width: 180px; margin-left: 10px">
            <el-option v-for="item in planTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          
          <el-button type="primary" icon="el-icon-search" style="margin-left: 10px" @click="handleSearch">查询</el-button>
          <el-button type="success" icon="el-icon-refresh" style="margin-left: 10px" @click="handleRefresh">刷新</el-button>
        </div>
      </el-card>
      
      <!-- 关键指标卡片 -->
      <el-row :gutter="20" class="panel-group">
        <el-col :span="6" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-plan">
              <i class="el-icon-s-claim card-panel-icon"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">本月随访计划数</div>
              <div class="card-panel-num">256</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-complete">
              <i class="el-icon-s-flag card-panel-icon"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">总体完成率</div>
              <div class="card-panel-num">89.5%</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-satisfaction">
              <i class="el-icon-star-on card-panel-icon"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">平均满意度</div>
              <div class="card-panel-num">4.7</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-exception">
              <i class="el-icon-warning-outline card-panel-icon"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">异常数据处理率</div>
              <div class="card-panel-num">96.2%</div>
            </div>
          </div>
        </el-col>
      </el-row>
      
      <!-- 图表展示区域 - 第一行 -->
      <el-row :gutter="20">
        <!-- 随访计划执行率统计 -->
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="chart-header">
              <span>随访计划执行率统计</span>
              <el-radio-group v-model="execRateTimeRange" size="mini" @change="changeExecRateTime">
                <el-radio-button label="week">周视图</el-radio-button>
                <el-radio-button label="month">月视图</el-radio-button>
                <el-radio-button label="quarter">季度视图</el-radio-button>
              </el-radio-group>
            </div>
            <div class="chart" id="execRateChart" style="height: 350px"></div>
          </el-card>
        </el-col>
        
        <!-- 按时执行比例 -->
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="chart-header">
              <span>按时执行比例</span>
              <el-dropdown @command="handleDeptChange">
                <span class="el-dropdown-link">
                  {{ currentDept || '全部科室' }} <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="">全部科室</el-dropdown-item>
                  <el-dropdown-item v-for="item in departmentOptions" :key="item.value" :command="item.value">{{ item.label }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="chart" id="execTimeChart" style="height: 350px"></div>
          </el-card>
        </el-col>
      </el-row>
      
      <!-- 图表展示区域 - 第二行 -->
      <el-row :gutter="20" style="margin-top: 20px">
        <!-- 模板使用统计 -->
        <el-col :span="8">
          <el-card class="box-card">
            <div slot="header" class="chart-header">
              <span>随访计划模板使用统计</span>
            </div>
            <div class="chart" id="templateChart" style="height: 350px"></div>
          </el-card>
        </el-col>
        
        <!-- 患者满意度统计 -->
        <el-col :span="8">
          <el-card class="box-card">
            <div slot="header" class="chart-header">
              <span>患者满意度统计</span>
            </div>
            <div class="chart" id="satisfactionChart" style="height: 350px"></div>
          </el-card>
        </el-col>
        
        <!-- 随访反馈词云 -->
        <el-col :span="8">
          <el-card class="box-card">
            <div slot="header" class="chart-header">
              <span>随访反馈评价词云</span>
              <el-radio-group v-model="feedbackType" size="mini" @change="changeFeedbackType">
                <el-radio-button label="positive">正面评价</el-radio-button>
                <el-radio-button label="negative">改进建议</el-radio-button>
              </el-radio-group>
            </div>
            <div class="chart" id="wordCloudChart" style="height: 350px"></div>
          </el-card>
        </el-col>
      </el-row>
      
      <!-- 图表展示区域 - 第三行 -->
      <el-row :gutter="20" style="margin-top: 20px">
        <!-- 异常数据处理情况 -->
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="chart-header">
              <span>异常数据处理情况</span>
            </div>
            <div class="chart" id="exceptionChart" style="height: 350px"></div>
          </el-card>
        </el-col>
        
        <!-- 医护人员工作量统计 -->
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="chart-header">
              <span>医护人员工作量统计</span>
              <el-select v-model="workloadType" placeholder="选择统计维度" size="mini" style="width: 130px" @change="changeWorkloadType">
                <el-option label="随访任务数" value="taskCount"></el-option>
                <el-option label="随访时长" value="timeSpent"></el-option>
                <el-option label="患者数量" value="patientCount"></el-option>
              </el-select>
            </div>
            <div class="chart" id="workloadChart" style="height: 350px"></div>
          </el-card>
        </el-col>
      </el-row>
      
      <!-- 科室执行情况排名 -->
      <el-card class="ranking-container" style="margin-top: 20px">
        <div slot="header" class="ranking-header">
          <span><i class="el-icon-medal"></i> 科室随访执行情况排名</span>
          <el-radio-group v-model="rankingMetric" size="mini" @change="changeRankingMetric">
            <el-radio-button label="completionRate">计划完成率</el-radio-button>
            <el-radio-button label="onTimeRate">按时完成率</el-radio-button>
            <el-radio-button label="satisfaction">患者满意度</el-radio-button>
          </el-radio-group>
        </div>
        
        <el-table :data="rankingData" border style="width: 100%">
          <el-table-column prop="rank" label="排名" width="80" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.rank <= 3" type="success">{{ scope.row.rank }}</el-tag>
              <span v-else>{{ scope.row.rank }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="department" label="科室" width="180"></el-table-column>
          <el-table-column prop="planCount" label="随访计划数" width="120"></el-table-column>
          <el-table-column prop="completeCount" label="已完成数" width="120"></el-table-column>
          <el-table-column prop="completionRate" label="计划完成率" width="120">
            <template slot-scope="scope">
              <el-progress :percentage="parseFloat(scope.row.completionRate)" :color="getColorByValue(scope.row.completionRate)"></el-progress>
            </template>
          </el-table-column>
          <el-table-column prop="onTimeRate" label="按时完成率" width="120">
            <template slot-scope="scope">
              <el-progress :percentage="parseFloat(scope.row.onTimeRate)" :color="getColorByValue(scope.row.onTimeRate)"></el-progress>
            </template>
          </el-table-column>
          <el-table-column prop="satisfaction" label="患者满意度" width="120">
            <template slot-scope="scope">
              <el-rate v-model="scope.row.satisfactionRate" disabled show-score text-color="#ff9900"></el-rate>
            </template>
          </el-table-column>
          <el-table-column prop="trend" label="趋势" width="180">
            <template slot-scope="scope">
              <div class="trend-chart" :id="'trend-' + scope.$index"></div>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </div>
  </template>
  
  <script>
  import * as echarts from 'echarts'
  import 'echarts-wordcloud'
  
  export default {
    name: 'ProjectManager',
    data() {
      return {
        // 筛选条件
        dateRange: ['2024-05-01', '2024-05-31'],
        department: [],
        planType: '',
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        departmentOptions: [
          { value: '呼吸科', label: '呼吸科' },
          { value: '肿瘤科', label: '肿瘤科' },
          { value: '泌尿科', label: '泌尿科' },
          { value: '心内科', label: '心内科' },
          { value: '消化科', label: '消化科' }
        ],
        planTypeOptions: [
          { value: '', label: '全部类型' },
          { value: '术后随访', label: '术后随访' },
          { value: '慢病管理', label: '慢病管理' },
          { value: '定期复查', label: '定期复查' },
          { value: '用药监测', label: '用药监测' },
          { value: '健康教育', label: '健康教育' }
        ],
        
        // 图表实例
        execRateChart: null,
        execTimeChart: null,
        templateChart: null,
        satisfactionChart: null,
        wordCloudChart: null,
        exceptionChart: null,
        workloadChart: null,
        trendCharts: [],
        
        // 控制参数
        execRateTimeRange: 'month',
        currentDept: '',
        feedbackType: 'positive',
        workloadType: 'taskCount',
        rankingMetric: 'completionRate',
        
        // 排名数据
        rankingData: [
          { rank: 1, department: '肿瘤科', planCount: 87, completeCount: 82, completionRate: 94.3, onTimeRate: 92.1, satisfaction: '4.8', satisfactionRate: 4.8, trend: [85, 88, 90, 93, 94] },
          { rank: 2, department: '心内科', planCount: 65, completeCount: 61, completionRate: 93.8, onTimeRate: 91.5, satisfaction: '4.7', satisfactionRate: 4.7, trend: [89, 91, 92, 94, 94] },
          { rank: 3, department: '消化科', planCount: 53, completeCount: 49, completionRate: 92.5, onTimeRate: 90.8, satisfaction: '4.6', satisfactionRate: 4.6, trend: [88, 90, 91, 92, 93] },
          { rank: 4, department: '呼吸科', planCount: 72, completeCount: 65, completionRate: 90.3, onTimeRate: 88.4, satisfaction: '4.5', satisfactionRate: 4.5, trend: [86, 87, 88, 89, 90] },
          { rank: 5, department: '泌尿科', planCount: 48, completeCount: 42, completionRate: 87.5, onTimeRate: 85.2, satisfaction: '4.4', satisfactionRate: 4.4, trend: [83, 84, 85, 86, 88] }
        ]
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.initCharts()
        this.renderTrendCharts()
      })
    },
    methods: {
      // 筛选相关方法
      handleSearch() {
        this.$message.success('筛选条件已应用')
        this.refreshCharts()
      },
      
      handleRefresh() {
        this.$message.success('数据已刷新')
        this.refreshCharts()
      },
      
      // 图表初始化方法
      initCharts() {
        this.initExecRateChart()
        this.initExecTimeChart()
        this.initTemplateChart()
        this.initSatisfactionChart()
        this.initWordCloudChart()
        this.initExceptionChart()
        this.initWorkloadChart()
        
        window.addEventListener('resize', this.resizeAllCharts)
      },
      
      // 各类图表切换视图方法
      changeExecRateTime() {
        this.initExecRateChart()
      },
      
      handleDeptChange(dept) {
        this.currentDept = dept
        this.initExecTimeChart()
      },
      
      changeFeedbackType() {
        this.initWordCloudChart()
      },
      
      changeWorkloadType() {
        this.initWorkloadChart()
      },
      
      changeRankingMetric() {
        // 根据不同指标重新排序数据
        if (this.rankingMetric === 'completionRate') {
          this.rankingData.sort((a, b) => b.completionRate - a.completionRate)
        } else if (this.rankingMetric === 'onTimeRate') {
          this.rankingData.sort((a, b) => b.onTimeRate - a.onTimeRate)
        } else {
          this.rankingData.sort((a, b) => b.satisfactionRate - a.satisfactionRate)
        }
        
        // 更新排名
        this.rankingData.forEach((item, index) => {
          item.rank = index + 1
        })
        
        this.$nextTick(() => {
          this.renderTrendCharts()
        })
      },
      
      // 随访计划执行率统计图表
      initExecRateChart() {
        if (this.execRateChart) {
          this.execRateChart.dispose()
        }
        
        this.execRateChart = echarts.init(document.getElementById('execRateChart'))
        
        let xAxisData = []
        let completionData = []
        let targetData = []
        
        if (this.execRateTimeRange === 'week') {
          xAxisData = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
          completionData = [88, 92, 86, 91, 94, 82, 78]
          targetData = [90, 90, 90, 90, 90, 80, 80]
        } else if (this.execRateTimeRange === 'month') {
          xAxisData = ['1周', '2周', '3周', '4周', '5周']
          completionData = [85, 89, 92, 94, 91]
          targetData = [90, 90, 90, 90, 90]
        } else {
          xAxisData = ['1月', '2月', '3月']
          completionData = [87, 91, 94]
          targetData = [85, 88, 90]
        }
        
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          legend: {
            data: ['实际完成率', '目标完成率']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xAxisData
          },
          yAxis: {
            type: 'value',
            min: 70,
            max: 100,
            axisLabel: {
              formatter: '{value}%'
            }
          },
          series: [
            {
              name: '实际完成率',
              type: 'line',
              data: completionData,
              smooth: true,
              lineStyle: {
                width: 3
              },
              itemStyle: {
                color: '#409EFF'
              },
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: 'rgba(64, 158, 255, 0.3)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(64, 158, 255, 0.1)'
                  }
                ])
              }
            },
            {
              name: '目标完成率',
              type: 'line',
              data: targetData,
              smooth: true,
              lineStyle: {
                width: 2,
                type: 'dashed'
              },
              itemStyle: {
                color: '#E6A23C'
              }
            }
          ]
        }
        
        this.execRateChart.setOption(option)
      },
      
      // 按时执行比例图表
      initExecTimeChart() {
        if (this.execTimeChart) {
          this.execTimeChart.dispose()
        }
        
        this.execTimeChart = echarts.init(document.getElementById('execTimeChart'))
        
        // 模拟不同科室/月份的数据
        const xAxisData = ['1月', '2月', '3月', '4月', '5月']
        const onTimeData = [65, 72, 78, 75, 82]
        const delayData = [20, 18, 16, 18, 12]
        const missedData = [15, 10, 6, 7, 6]
        
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            },
            formatter: function(params) {
              let tooltip = params[0].axisValueLabel + '<br/>'
              let total = 0
              params.forEach(item => {
                total += item.value
                tooltip += item.marker + ' ' + item.seriesName + ': ' + item.value + '%<br/>'
              })
              tooltip += '<br/>总计: 100%'
              return tooltip
            }
          },
          legend: {
            data: ['准时完成', '延迟完成', '未完成']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: xAxisData
          },
          yAxis: {
            type: 'value',
            max: 100,
            axisLabel: {
              formatter: '{value}%'
            }
          },
          series: [
            {
              name: '准时完成',
              type: 'bar',
              stack: '总量',
              emphasis: {
                focus: 'series'
              },
              data: onTimeData,
              itemStyle: {
                color: '#67C23A'
              }
            },
            {
              name: '延迟完成',
              type: 'bar',
              stack: '总量',
              emphasis: {
                focus: 'series'
              },
              data: delayData,
              itemStyle: {
                color: '#E6A23C'
              }
            },
            {
              name: '未完成',
              type: 'bar',
              stack: '总量',
              emphasis: {
                focus: 'series'
              },
              data: missedData,
              itemStyle: {
                color: '#F56C6C'
              }
            }
          ]
        }
        
        this.execTimeChart.setOption(option)
      },
      
      // 模板使用统计图表
      initTemplateChart() {
        if (this.templateChart) {
          this.templateChart.dispose()
        }
        
        this.templateChart = echarts.init(document.getElementById('templateChart'))
        
        const option = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
          legend: {
            orient: 'vertical',
            right: 10,
            top: 'center',
            data: ['术后随访模板', '慢病管理模板', '定期复查模板', '用药监测模板', '健康教育模板']
          },
          series: [
            {
              name: '模板使用情况',
              type: 'pie',
              radius: '65%',
              center: ['40%', '50%'],
              data: [
                { value: 35, name: '术后随访模板' },
                { value: 25, name: '慢病管理模板' },
                { value: 20, name: '定期复查模板' },
                { value: 15, name: '用药监测模板' },
                { value: 5, name: '健康教育模板' }
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]
        }
        
        this.templateChart.setOption(option)
      },
      
      // 患者满意度统计图表
      initSatisfactionChart() {
        if (this.satisfactionChart) {
          this.satisfactionChart.dispose()
        }
        
        this.satisfactionChart = echarts.init(document.getElementById('satisfactionChart'))
        
        const option = {
          tooltip: {
            trigger: 'item',
            formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
          legend: {
            bottom: '5%',
            left: 'center',
            data: ['非常满意', '满意', '一般', '不满意', '非常不满意']
          },
          series: [
            {
              name: '患者满意度',
              type: 'pie',
              radius: ['40%', '70%'],
              avoidLabelOverlap: false,
              itemStyle: {
                borderRadius: 10,
                borderColor: '#fff',
                borderWidth: 2
              },
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: '18',
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },
              data: [
                { value: 55, name: '非常满意', itemStyle: { color: '#67C23A' } },
                { value: 32, name: '满意', itemStyle: { color: '#85ce61' } },
                { value: 10, name: '一般', itemStyle: { color: '#E6A23C' } },
                { value: 2, name: '不满意', itemStyle: { color: '#f89b9b' } },
                { value: 1, name: '非常不满意', itemStyle: { color: '#F56C6C' } }
              ]
            }
          ]
        }
        
        this.satisfactionChart.setOption(option)
      },
      
      // 随访反馈词云图
      initWordCloudChart() {
        if (this.wordCloudChart) {
          this.wordCloudChart.dispose()
        }
        
        this.wordCloudChart = echarts.init(document.getElementById('wordCloudChart'))
        
        let data = []
        if (this.feedbackType === 'positive') {
          data = [
            { name: '服务态度好', value: 80 },
            { name: '解释清晰', value: 75 },
            { name: '有耐心', value: 72 },
            { name: '专业', value: 68 },
            { name: '回复及时', value: 65 },
            { name: '关心患者', value: 60 },
            { name: '热情', value: 58 },
            { name: '沟通顺畅', value: 55 },
            { name: '医疗水平高', value: 53 },
            { name: '责任心强', value: 50 },
            { name: '关注细节', value: 48 },
            { name: '指导详细', value: 45 },
            { name: '治疗有效', value: 43 },
            { name: '随访准时', value: 40 },
            { name: '效果明显', value: 38 },
            { name: '很温暖', value: 35 },
            { name: '体贴', value: 33 },
            { name: '很安心', value: 30 },
            { name: '感谢', value: 28 },
            { name: '非常好', value: 25 }
          ]
        } else {
          data = [
            { name: '随访频率不够', value: 65 },
            { name: '等待时间长', value: 60 },
            { name: '回复不及时', value: 55 },
            { name: '解释不够详细', value: 50 },
            { name: '指导不明确', value: 45 },
            { name: '随访形式单一', value: 40 },
            { name: '随访时间不固定', value: 35 },
            { name: '希望面诊', value: 30 },
            { name: '交流不充分', value: 28 },
            { name: '操作不便', value: 25 },
            { name: '信息获取难', value: 23 },
            { name: '提醒不够', value: 20 },
            { name: '电话干扰工作', value: 18 },
            { name: '内容重复', value: 15 },
            { name: '缺乏个性化', value: 13 },
            { name: '希望增加频率', value: 10 },
            { name: '不够人性化', value: 8 },
            { name: '线上不方便', value: 5 }
          ]
        }
        
        const option = {
          tooltip: {
            show: true
          },
          series: [{
            type: 'wordCloud',
            shape: 'circle',
            left: 'center',
            top: 'center',
            width: '90%',
            height: '90%',
            right: null,
            bottom: null,
            sizeRange: [12, 60],
            rotationRange: [-90, 90],
            rotationStep: 45,
            gridSize: 8,
            drawOutOfBound: false,
            textStyle: {
              fontFamily: 'sans-serif',
              fontWeight: 'bold',
              color: function() {
                return 'rgb(' + 
                  Math.round(Math.random() * 155 + 100) + ',' +
                  Math.round(Math.random() * 155 + 100) + ',' +
                  Math.round(Math.random() * 155 + 100) + ')'
              }
            },
            emphasis: {
              focus: 'self',
              textStyle: {
                shadowBlur: 10,
                shadowColor: '#333'
              }
            },
            data: data
          }]
        }
        
        this.wordCloudChart.setOption(option)
      },
      
      // 异常数据处理情况图表
      initExceptionChart() {
        if (this.exceptionChart) {
          this.exceptionChart.dispose()
        }
        
        this.exceptionChart = echarts.init(document.getElementById('exceptionChart'))
        
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            data: ['异常数据总量', '已处理数据', '平均处理时间(小时)']
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'value',
            axisLabel: {
              formatter: '{value}'
            },
            splitLine: {
              show: false
            }
          },
          yAxis: {
            type: 'category',
            inverse: true,
            data: ['资料缺失', '随访超时', '量表异常', '不良反应', '患者投诉'],
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                color: '#333'
              }
            }
          },
          series: [
            {
              name: '异常数据总量',
              type: 'bar',
              stack: 'total',
              label: {
                show: true
              },
              emphasis: {
                focus: 'series'
              },
              data: [45, 38, 32, 25, 18],
              itemStyle: {
                color: '#F56C6C'
              }
            },
            {
              name: '已处理数据',
              type: 'bar',
              stack: 'total',
              label: {
                show: true,
                position: 'inside',
                formatter: '{c}',
                offset: [0, -20],
                color: '#fff',
                fontSize: 12
              },
              emphasis: {
                focus: 'series'
              },
              data: [-43, -37, -30, -24, -17],
              itemStyle: {
                color: '#67C23A'
              }
            },
            {
              name: '平均处理时间(小时)',
              type: 'line',
              yAxisIndex: 0,
              data: [4.8, 6.2, 3.5, 8.7, 2.1],
              symbol: 'circle',
              symbolSize: 8,
              itemStyle: {
                color: '#409EFF'
              },
              label: {
                show: true,
                formatter: '{c}h',
                color: '#409EFF'
              }
            }
          ]
        }
        
        this.exceptionChart.setOption(option)
      },
      
      // 医护人员工作量统计图表
      initWorkloadChart() {
        if (this.workloadChart) {
          this.workloadChart.dispose()
        }
        
        this.workloadChart = echarts.init(document.getElementById('workloadChart'))
        
        let data = []
        let yAxisName = ''
        
        if (this.workloadType === 'taskCount') {
          data = [
            { value: 68, name: '张医生' },
            { value: 65, name: '李医生' },
            { value: 60, name: '王医生' },
            { value: 56, name: '赵护士' },
            { value: 54, name: '刘医生' },
            { value: 50, name: '孙护士' },
            { value: 48, name: '钱医生' },
            { value: 44, name: '周护士' }
          ]
          yAxisName = '随访任务数(个)'
        } else if (this.workloadType === 'timeSpent') {
          data = [
            { value: 86, name: '张医生' },
            { value: 78, name: '王医生' },
            { value: 75, name: '李医生' },
            { value: 72, name: '刘医生' },
            { value: 68, name: '赵护士' },
            { value: 65, name: '钱医生' },
            { value: 62, name: '孙护士' },
            { value: 58, name: '周护士' }
          ]
          yAxisName = '随访时长(小时)'
        } else {
          data = [
            { value: 125, name: '李医生' },
            { value: 118, name: '张医生' },
            { value: 110, name: '王医生' },
            { value: 102, name: '刘医生' },
            { value: 98, name: '钱医生' },
            { value: 95, name: '赵护士' },
            { value: 85, name: '孙护士' },
            { value: 78, name: '周护士' }
          ]
          yAxisName = '随访患者数(人)'
        }
        
        // 排序数据
        data.sort((a, b) => b.value - a.value)
        
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: {
            type: 'value',
            name: yAxisName,
            axisLabel: {
              formatter: '{value}'
            }
          },
          yAxis: {
            type: 'category',
            data: data.map(item => item.name),
            axisLine: {
              lineStyle: {
                color: '#333'
              }
            },
            axisTick: {
              show: false
            }
          },
          series: [
            {
              name: this.workloadType === 'taskCount' ? '随访任务数' : this.workloadType === 'timeSpent' ? '随访时长' : '随访患者数',
              type: 'bar',
              data: data.map(item => {
                return {
                  value: item.value,
                  itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                      { offset: 0, color: '#83bff6' },
                      { offset: 0.5, color: '#409EFF' },
                      { offset: 1, color: '#188df0' }
                    ])
                  }
                }
              }),
              label: {
                show: true,
                position: 'right',
                formatter: '{c}'
              }
            }
          ]
        }
        
        this.workloadChart.setOption(option)
      },
      
      // 渲染小趋势图
      renderTrendCharts() {
        // 先清理现有图表
        this.trendCharts.forEach(chart => {
          chart.dispose()
        })
        this.trendCharts = []
        
        // 为每行渲染趋势图
        this.rankingData.forEach((item, index) => {
          const chartDom = document.getElementById('trend-' + index)
          if (chartDom) {
            const trendChart = echarts.init(chartDom)
            
            // 根据rankingMetric决定显示哪个数据系列
            let data = []
            let color = ''
            
            if (this.rankingMetric === 'completionRate') {
              data = item.trend
              color = '#409EFF'
            } else if (this.rankingMetric === 'onTimeRate') {
              data = item.trend.map(val => val - Math.floor(Math.random() * 5))
              color = '#E6A23C'
            } else {
              data = item.trend.map(val => val - Math.floor(Math.random() * 8))
              color = '#67C23A'
            }
            
            const option = {
              animation: false,
              grid: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
              },
              xAxis: {
                type: 'category',
                show: false,
                boundaryGap: false
              },
              yAxis: {
                type: 'value',
                show: false,
                min: function(value) {
                  return value.min - 5
                }
              },
              series: [
                {
                  type: 'line',
                  data: data,
                  showSymbol: false,
                  lineStyle: {
                    color: color,
                    width: 2
                  },
                  areaStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      {
                        offset: 0,
                        color: color.replace(')', ', 0.3)')
                      },
                      {
                        offset: 1,
                        color: color.replace(')', ', 0.1)')
                      }
                    ])
                  }
                }
              ]
            }
            
            trendChart.setOption(option)
            this.trendCharts.push(trendChart)
          }
        })
      },
      
      // 刷新所有图表
      refreshCharts() {
        this.initExecRateChart()
        this.initExecTimeChart()
        this.initTemplateChart()
        this.initSatisfactionChart()
        this.initWordCloudChart()
        this.initExceptionChart()
        this.initWorkloadChart()
        this.renderTrendCharts()
      },
      
      // 适应窗口大小变化
      resizeAllCharts() {
        this.execRateChart && this.execRateChart.resize()
        this.execTimeChart && this.execTimeChart.resize()
        this.templateChart && this.templateChart.resize()
        this.satisfactionChart && this.satisfactionChart.resize()
        this.wordCloudChart && this.wordCloudChart.resize()
        this.exceptionChart && this.exceptionChart.resize()
        this.workloadChart && this.workloadChart.resize()
        this.trendCharts.forEach(chart => {
          chart && chart.resize()
        })
      },
      
      // 根据值获取颜色
      getColorByValue(value) {
        value = parseFloat(value)
        if (value < 80) {
          return '#F56C6C'
        } else if (value < 90) {
          return '#E6A23C'
        } else {
          return '#67C23A'
        }
      }
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resizeAllCharts)
      this.execRateChart && this.execRateChart.dispose()
      this.execTimeChart && this.execTimeChart.dispose()
      this.templateChart && this.templateChart.dispose()
      this.satisfactionChart && this.satisfactionChart.dispose()
      this.wordCloudChart && this.wordCloudChart.dispose()
      this.exceptionChart && this.exceptionChart.dispose()
      this.workloadChart && this.workloadChart.dispose()
      this.trendCharts.forEach(chart => {
        chart && chart.dispose()
      })
    }
  }
  </script>
  
  <style scoped>
  .dashboard-container {
    padding: 20px;
  }
  
  .filter-container {
    margin-bottom: 20px;
  }
  
  .filter-item {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
  
  /* 指标卡片样式 */
  .panel-group {
    margin: 20px 0;
  }
  
  .card-panel {
    height: 108px;
    cursor: pointer;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    border-color: rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
  }
  
  .card-panel-icon-wrapper {
    float: left;
    margin: 14px 0 0 14px;
    padding: 16px;
    border-radius: 8px;
    transition: all 0.38s ease-out;
  }
  
  .card-panel-icon {
    float: left;
    font-size: 32px;
    color: #fff;
  }
  
  .icon-plan {
    background: #409EFF;
  }
  
  .icon-complete {
    background: #67C23A;
  }
  
  .icon-satisfaction {
    background: #E6A23C;
  }
  
  .icon-exception {
    background: #F56C6C;
  }
  
  .card-panel-description {
    float: right;
    font-weight: bold;
    margin: 26px 26px 0 0;
  }
  
  .card-panel-text {
    font-size: 16px;
    color: rgba(0, 0, 0, 0.45);
    margin-bottom: 12px;
  }
  
  .card-panel-num {
    font-size: 24px;
    font-weight: 600;
  }
  
  /* 图表区域样式 */
  .chart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  
  /* 排名区域样式 */
  .ranking-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .trend-chart {
    width: 100%;
    height: 50px;
  }
  </style>